export const SET_EDITING_ASSIGNED_CONTENT = "SET_EDITING_ASSIGNED_CONTENT";
export const RESET_EDITING_ASSIGNED_CONTENT = "RESET_EDITING_ASSIGNED_CONTENT";
export const MARK_AS_WATCHED_EDITING_ASSIGNED_CONTENT =
  "MARK_AS_WATCHED_EDITING_ASSIGNED_CONTENT";
export const MARK_AS_TO_WATCH_EDITING_ASSIGNED_CONTENT =
  "MARK_AS_TO_WATCH_EDITING_ASSIGNED_CONTENT";
export const SET_ALL_MY_ASSIGNED_CONTENT = "SET_ALL_MY_ASSIGNED_CONTENT";
export const SET_UPDATED_CONTENT_IN_LIST = "SET_UPDATED_CONTENT_IN_LIST";
export const SET_CONTENT_TYPES = "SET_CONTENT_TYPES";
export const RESET_CURRENT_CONTENT = "RESET_CURRENT_CONTENT";
export const SET_RELATED_CONTENT = "SET_RELATED_CONTENT";
